import { useEffect, useMemo, useState } from "react";
import { ChevronDown, Search, ExternalLink } from "lucide-react";

const S = (n, label, tab, extra = {}) => ({ n, label, tab, ...extra });
export const NAV = [
  { n: "1", label: "Dashboard operativa", items: [S("1", "Panoramica", "dashboard")] },
  { n: "2", label: "Web Scraping & Analisi", items: [S("2.1", "Lead Gen & scraping (mappa)", "leadgen"), S("2.2", "Nuova analisi URL", null, { href: "/" }),
    S("2.3", "Storico analisi", "analyses"), S("2.4", "Suggerimenti AI generati", null)] },
  { n: "3", label: "Social Pilot", items: [S("3.1", "Social Pilot · Reel & Stories", "socialpilot")] },
  { n: "4", label: "Gestione ADV WEB", items: [S("4.1", "Bozze Google Ads · Zernio · PropellerAds", "advweb"), S("4.2", "Campagna ADV · Google ADV", null, { href: "https://ads.google.com/", button: true }), S("4.3", "Campagna ADV · Propeller Ads", null, { href: "https://partners.propellerads.com/campaigns/create", button: true })] },
  { n: "5", label: "Ordini e Pagamenti", items: [S("5.1", "Ordini ricevuti", "orders"), S("5.2", "Pagamenti confermati", "transactions"), S("5.3", "Stato avanzamento", "managed")] },
  { n: "6", label: "Gestione Progetti Cliente", items: [S("6.1", "Progetti attivi", null), S("6.2", "Task e milestone", null), S("6.3", "Deliverable", null)] },
  { n: "7", label: "Campagne & Servizi Attivi", items: [S("7.1", "ADV sito · servizi aggiuntivi", "managed", { badge: "addons" }), S("7.2", "Social ADS (Meta)", "campaigns"),
    S("7.3", "Follower reali", null), S("7.4", "Banner Aurora®", null), S("7.5", "Email marketing massivo", null), S("7.6", "Catalogo servizi & Kit", "catalog")] },
  { n: "8", label: "Clienti (CRM)", items: [S("8.1", "Anagrafica", "users"), S("8.2", "Comunicazioni", "chat", { badge: "chat" }), S("8.3", "Ticket supporto", null), S("8.4", "Statistiche chatbot", "chatbotstats")] },
  { n: "9", label: "Report & Analytics Cliente", items: [S("9.1", "Generazione report", "managed"), S("9.2", "Mappa di calore", "heatmap"), S("9.3", "Pagina pubblica dati cliente", null), S("9.4", "Visitatori del sito", "visitors")] },
  { n: "10", label: "Impostazioni Piattaforma", items: [S("10.1", "Lingue", null), S("10.2", "Keyword ricerca", null), S("10.3", "Sicurezza · API keys", "keys")] },
  { n: "11", label: "Fatturazione", items: [S("11.1", "Fatture emesse", "invoices"), S("11.2", "Note di credito", null)] },
  { n: "12", label: "Marketing & Marginalità", items: [S("12.1", "Codici sconto", "discounts"), S("12.2", "Promozioni attive", null), S("12.3", "Marginalità e KPI economici", "margins")] },
];
export const ALL_ITEMS = NAV.flatMap((g) => g.items.map((i) => ({ ...i, group: g })));
// Set true to show the "In arrivo" (frozen) entries again.
const SHOW_FROZEN = false;
const ACTIVE_NAV = NAV.map((g) => ({ ...g, items: g.items.filter((i) => SHOW_FROZEN || i.tab || i.href) })).filter((g) => g.items.length);
const OPEN_KEY = "aurora_admin_nav_open";

const Item = ({ it, active, count, onPick }) => {
  const soon = !it.tab && !it.href;
  const cls = `w-full flex items-center gap-2 px-3 py-1.5 text-[13px] text-left transition-colors ${active ? "bg-white text-[#2B3036] font-semibold border-l-2 border-[#E0262C]" : soon ? "text-[#9ca3af] cursor-not-allowed" : "text-[#4b5563] hover:text-[#E0262C] hover:bg-white/60"}`;
  const body = (
    <>
      <span className="font-mono text-[10px] text-[#9ca3af] w-8 flex-shrink-0">{it.n}</span>
      <span className="flex-1 truncate">{it.label}</span>
      {soon && <span className="text-[8px] uppercase font-mono border border-[#d5dbde] px-1 py-px">In arrivo</span>}
      {count > 0 && <span data-testid={`nav-badge-${it.n}`} className="min-w-[18px] h-[18px] px-1 aurora-gradient text-white text-[10px] font-bold flex items-center justify-center rounded-full">{count}</span>}
    </>
  );
  if (it.button) return (
    <a data-testid={`nav-item-${it.n}`} href={it.href} target="_blank" rel="noopener noreferrer"
      className="mx-2 my-1 flex items-center gap-2 px-3 py-2 text-[12px] font-semibold text-white aurora-gradient hover:opacity-90 transition-opacity">
      <span className="font-mono text-[10px] text-white/70 w-8 flex-shrink-0">{it.n}</span><span className="flex-1 truncate">{it.label}</span><ExternalLink className="w-3.5 h-3.5" />
    </a>
  );
  if (it.href) return <a data-testid={`nav-item-${it.n}`} href={it.href} target="_blank" rel="noreferrer" className={cls}>{body}</a>;
  return <button data-testid={`nav-item-${it.n}`} disabled={soon} onClick={() => onPick(it)} className={cls}>{body}</button>;
};

export const AdminNav = ({ current, onPick, badges }) => {
  const [q, setQ] = useState("");
  const [mobileOpen, setMobileOpen] = useState(false);
  const [open, setOpen] = useState(() => { try { return JSON.parse(localStorage.getItem(OPEN_KEY)) || { 1: true, 2: true, 3: true, 5: true }; } catch { return {}; } });
  useEffect(() => localStorage.setItem(OPEN_KEY, JSON.stringify(open)), [open]);
  const groups = useMemo(() => {
    const s = q.trim().toLowerCase();
    return s ? ACTIVE_NAV.map((g) => ({ ...g, items: g.items.filter((i) => `${i.n} ${i.label} ${g.label}`.toLowerCase().includes(s)) })).filter((g) => g.items.length) : ACTIVE_NAV;
  }, [q]);
  return (
    <aside data-testid="admin-nav" className="lg:sticky lg:top-16 lg:h-[calc(100vh-4rem)] lg:w-72 flex-shrink-0 flex flex-col border border-[#d5dbde] lg:border-y-0 lg:border-l-0 bg-[#dde2e5]">
      <button data-testid="admin-nav-toggle" onClick={() => setMobileOpen((v) => !v)} className="lg:hidden flex items-center justify-between px-4 py-3 text-xs uppercase tracking-wider font-semibold">
        Menu · {current} <ChevronDown className={`w-4 h-4 transition-transform ${mobileOpen ? "rotate-180" : ""}`} />
      </button>
      <div className={`${mobileOpen ? "flex" : "hidden"} lg:flex flex-col flex-1 min-h-0`}>
      <div className="p-3 border-b border-[#d5dbde]">
        <div className="relative">
          <Search className="w-3.5 h-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-[#9ca3af]" />
          <input data-testid="admin-nav-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca nel menu…"
            className="w-full h-8 pl-8 pr-2 text-xs bg-white border border-[#d5dbde] rounded-sm focus:outline-none focus:border-[#2B3036]" />
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto py-2 max-h-[60vh] lg:max-h-none">
        {groups.map((g) => {
          const isOpen = q || open[g.n];
          const total = g.items.reduce((a, i) => a + (badges[i.badge] || 0), 0);
          return (
            <div key={g.n} className="mb-1">
              <button data-testid={`nav-group-${g.n}`} onClick={() => setOpen((p) => ({ ...p, [g.n]: !p[g.n] }))}
                className="w-full flex items-center gap-2 px-3 py-2 text-[11px] uppercase tracking-wider font-semibold text-[#2B3036] hover:text-[#E0262C] transition-colors">
                <span className="font-mono w-6 text-[#E0262C]">{g.n}.</span>
                <span className="flex-1 text-left">{g.label}</span>
                {!isOpen && total > 0 && <span className="w-2 h-2 rounded-full bg-[#E0262C]" />}
                <ChevronDown className={`w-3.5 h-3.5 transition-transform ${isOpen ? "" : "-rotate-90"}`} />
              </button>
              {isOpen && g.items.map((it) => <Item key={it.n} it={it} active={current === it.n} count={badges[it.badge] || 0} onPick={(x) => { onPick(x); setMobileOpen(false); }} />)}
            </div>
          );
        })}
      </nav>
      </div>
    </aside>
  );
};

export const Breadcrumb = ({ current }) => {
  const it = ALL_ITEMS.find((i) => i.n === current);
  if (!it) return null;
  return (
    <div data-testid="admin-breadcrumb" className="flex items-center gap-2 text-xs font-mono text-[#6b7280] mb-5">
      <span>{it.group.n} · {it.group.label}</span><span className="text-[#E0262C]">›</span>
      <span className="text-[#2B3036] font-semibold">{it.n} {it.label}</span>
    </div>
  );
};
